module.exports = __webpack_public_path__ + "img/mobproctoring.4d995148.svg";